import { FeatureToggleType } from '../enum/FeatureToggleType'

export const parseFeatureToggleMap = (input: string): Map<FeatureToggleType, boolean> => {
  const featureToggles = new Map<FeatureToggleType, boolean>()
  if (input.length !== 0) {
    const obj = JSON.parse(input)
    Object.keys(obj).forEach((x) => {
      if (x in FeatureToggleType) {
        const value = obj[x] === 'true'
        featureToggles.set(x as unknown as FeatureToggleType, value)
      }
    })
  }
  return featureToggles
}
